import React from "react";
import { ConfirmationBar } from "./confirmation-bar";
import { ConfirmationBarAcceptButton } from "./confirmation-bar-accept-button";
import { ConfirmationBarCancelButton } from "./confirmation-bar-cancel-button";

export const AcceptCancelConfirmationBar = ({
	title,
	disabled,
	className,
	onAccept,
	onCancel,
}: {
	title?: string;
	disabled?: boolean;
	className?: string;
	onAccept: () => void;
	onCancel: () => void;
}) => (
	<ConfirmationBar
		className={className}
		left={
			<ConfirmationBarCancelButton
				disabled={disabled}
				onClick={() => {
					onCancel();
				}}
			/>
		}
		right={
			<ConfirmationBarAcceptButton
				disabled={disabled}
				onClick={() => {
					onAccept();
				}}
			/>
		}
		title={title}
	/>
);
AcceptCancelConfirmationBar.displayName = "AcceptCancelConfirmationBar";
